import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ivory text-navy border-t border-navy/10" data-testid="site-footer">
      <div className="container-zt py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <Logo tone="light" />
            <p className="mt-8 max-w-md text-sm leading-relaxed text-navy/65 font-light">
              ZT Global is an international capital structuring and strategic advisory
              platform, anchored in the Dubai International Financial Centre and regulated
              by the DFSA, with a global investment and advisory focus.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <p className="label-zt text-gold-600">Explore</p>
            <ul className="mt-6 space-y-3 text-sm text-navy/70">
              <li><Link to="/" className="hover:text-gold-600 transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/leadership" className="hover:text-gold-600 transition-colors" data-testid="footer-link-leadership">Leadership</Link></li>
              <li><Link to="/contact" className="hover:text-gold-600 transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p className="label-zt text-gold-600">Contact</p>
            <ul className="mt-6 space-y-4 text-sm text-navy/70">
              <li className="flex items-start gap-3">
                <Mail size={14} className="mt-1 text-gold-600" />
                <a href="mailto:info@ztglobal.com" className="hover:text-gold-600 transition-colors" data-testid="footer-email">
                  info@ztglobal.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={14} className="mt-1 text-gold-600" />
                <a href="tel:+97144019490" className="hover:text-gold-600 transition-colors" data-testid="footer-phone">
                  +971 4 40 19490
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="mt-1 text-gold-600" />
                <span>
                  Level 1, DIFC Funds Centre, Precinct Building 4<br />
                  Dubai International Financial Centre, Dubai, UAE
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="h-px bg-navy/10 mt-16" />

        <div className="mt-8 flex flex-col md:flex-row md:items-start md:justify-between gap-6 text-[11px] uppercase tracking-[0.25em] text-navy/45">
          <p>© {year} ZT Global. All rights reserved.</p>
          <p className="md:max-w-xl md:text-right normal-case tracking-normal text-[11px] text-navy/55 leading-relaxed">
            Regulated by Dubai Financial Services Authority (DFSA) License Number CL 13739.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
